import { all } from "redux-saga/effects";
import DashboardWatcherSaga from "./Dashboard/DashboardWatcherSaga";
import LanguagesWatcherSaga from "./Languages/LanguageWatcherSaga";
import LoginAndRegisterWatcherSaga from "./LoginAndRegister/LoginAndRegisterWatcherSaga";
import ProfileWatcherSaga from "./Profile/ProfileWatcherSaga";
import LayoutWatcherSaga from "./Layout/LayoutWatcherSaga";
import TWGWatcherSaga from "./TWG/TWGWatcherSaga";
import UsersWatcherSaga from "./Users/UsersWatcherSaga";
import NotificationWatcherSaga from "./Notifications/NotificationWatcherSaga";
import GivingsWatcherSaga from "./Givings/GivingsWatcherSaga";
import TestimonyWatcherSaga from "./Testimony/TestimonyWatcherSaga";
import TabsWatcherSaga from './Tab/saga'
import ChurchesWatcherSaga from "./Churches/sagas";
import ResouceWatchSaga from "./Resources/saga";
import TeamWatcherSaga from "./Team/saga";
import ProgramWatcherSaga from "./Program/programSaga";
import BulletinWatcherSaga from "./Bulletin/bulletinSaga";
import CarecellWatcherSaga from './Carecells/saga'
import CarecellCoverImageWatcherSaga from "./CarecellCoverImage/carecellCoverImageSaga";
import ProgramCoverImageSaga from "./ProgramCoverImage/saga";
import TeamCoverImageWatcherSaga from "./TeamCoverImage/saga";
import BulletinCoverImageWatcherSaga from "./BulletinCoverImage/bulletinCoverImageSaga";
import BibleWatcherSaga from "./Bible/BibleWatcherSaga";
import GalleryWatcherSaga from "./Gallery/gallerySaga"
import churchCoverImageWatcherSaga from "./ChurchCoverImage/churchCoverImageSaga";
import campusesWatcherSaga from "./Campuse/campusesSaga";
import servicesWatcherSaga from "./Service/servicesSaga";
import languageMetaWatcherSaga from "./ChurchLanguage/saga";
import programLanguageMetaWatcherSaga from "./ProgramLanguage/saga";
import ministryWatcherSaga from "./Ministry/saga";
import channelsWatcherSaga from "./Channels/saga";
import teamlanguageWatcherSaga from "./TeamLanguage/saga";
import giveSettingWatcherSaga from "./GiveSetting/giveSettingSaga";
import videoResourcesWatcherSaga from "./VideoResouce/videoResourcesSaga";
import churchVideoWatcherSaga from "./ChurchVideos/churchVideoSaga";
import bulletinVideosWatcherSaga from "./BulletinVideo/bulletinVideosSaga";
import programVideosWatcherSaga from "./ProgramVIdeo/programVideosSaga";
import resourceVideosWatcherSaga from "./ResouceVideo/resourceVideosSaga";
import carecellVideoWatcherSaga from "./carecellVideo/carecellVideoSaga";
import serviceVideoWatcherSaga from "./ServiceVideo/serviceVideosSaga";
import campusVideoWatcherSaga from "./CampusVideo/CampusVideoSaga";
import teamVideoWatcherSaga from "./TeamVideo/teamVideoSaga";
import planWatcherSaga from "./Plan/planSaga";
import sermonStudiesWatcherSaga from "./SermonStudies/sermonStudiesSaga";
import PlansWatcherSaga from "./planChurch/saga";
import GroupsWatcherSaga from "./Group/saga";
import HomeWatcherSaga from "./Home/HomeWatcher";
import CurriclumWatcherSaga from "./Curriculum/CurriculumWatcher";
import TetimonialWatcherSaga from "./Testimonial/TestimonialWatcher";
import PrayersWatcherSaga from "./Prayer/PrayersSaga";
import agreementsWatcherSaga from "./Agreements/agreementsSaga";
import entityAnalyticsWatcherSaga from "./EntityAnalytics/entityAnalyticsSaga";
export function* webportalAppRootSaga() {
    yield all([
        DashboardWatcherSaga(),
        LanguagesWatcherSaga(),
        LoginAndRegisterWatcherSaga(),
        ProfileWatcherSaga(),
        LayoutWatcherSaga(),
        TWGWatcherSaga(),
        UsersWatcherSaga(),
        NotificationWatcherSaga(),
        GivingsWatcherSaga(),
        TestimonyWatcherSaga(),
        TabsWatcherSaga(),
        ChurchesWatcherSaga(),
        ResouceWatchSaga(),
        TeamWatcherSaga(),
        ProgramWatcherSaga(),
        BulletinWatcherSaga(),
        CarecellWatcherSaga(),
        CarecellCoverImageWatcherSaga(),
        ProgramCoverImageSaga(),
        TeamCoverImageWatcherSaga(),
        BulletinCoverImageWatcherSaga(),
        BibleWatcherSaga(),
        GalleryWatcherSaga(),
        churchCoverImageWatcherSaga(),
        campusesWatcherSaga(),
        servicesWatcherSaga(),
        languageMetaWatcherSaga(),
        programLanguageMetaWatcherSaga(),
        ministryWatcherSaga(),
        channelsWatcherSaga(),
        teamlanguageWatcherSaga(),
        giveSettingWatcherSaga(),
        videoResourcesWatcherSaga(),
        churchVideoWatcherSaga(),
        bulletinVideosWatcherSaga(),
        programVideosWatcherSaga(),
        resourceVideosWatcherSaga(),
        carecellVideoWatcherSaga(),
        serviceVideoWatcherSaga(),
        campusVideoWatcherSaga(),
        teamVideoWatcherSaga(),
        planWatcherSaga(),
        sermonStudiesWatcherSaga(),
        PlansWatcherSaga(),
        GroupsWatcherSaga(),
        HomeWatcherSaga(),
        CurriclumWatcherSaga(),
        TetimonialWatcherSaga(),
        PrayersWatcherSaga(),
        agreementsWatcherSaga(),
        entityAnalyticsWatcherSaga()

    ])
}
